<div class="admin-help-section">
  <h2 class="section-title help-title">Help Articles</h2>

  <div class="help-tabs-container">
    <div class="help-tab-content">
      <div class="help-contact-content">
        <div class="contact-section-heading">
          <h3 class="help-content-title help-content-title--accent">Guides and tutorials</h3>
        </div>

        <div class="contact-card contact-card--resources">
          <div class="resource-group resource-group--scrollable">
            <div class="resource-list resource-list--cards">
              <div class="resource-item resource-item--document" *ngFor="let resource of helpResources">
                <div class="resource-item-body">
                  <div class="resource-card-top">
                    <div
                      class="resource-card-icon"
                      [class.resource-card-icon--document]="resource.resourceType === 'document'"
                      [class.resource-card-icon--video]="resource.resourceType === 'video'">
                      <mat-icon>{{ resource.icon }}</mat-icon>
                    </div>

                    <span
                      class="resource-card-tag"
                      [class.resource-card-tag--video]="resource.resourceType === 'video'">
                      {{ resource.resourceType === 'video' ? 'Video' : 'Document' }}
                    </span>
                  </div>

                  <div class="resource-item-title">{{ resource.title }}</div>
                  <p class="resource-card-description">{{ resource.description }}</p>

                  <div class="resource-card-footer">
                    <div class="resource-card-meta">
                      <span class="resource-card-meta-item" *ngFor="let meta of resource.metaItems"
                        [class.resource-card-meta-item--duration]="meta.icon === 'timer'">
                        <mat-icon>{{ meta.icon }}</mat-icon>
                        <span>{{ meta.label }}</span>
                      </span>
                    </div>

                    <div class="resource-card-action-link">
                      <button
                        type="button"
                        class="resource-card-action-button"
                        [attr.aria-label]="resource.resourceType === 'video' ? 'Watch ' + resource.title : 'Download ' + resource.title"
                        [class.resource-card-action-link--disabled]="resource.resourceType === 'video' && isOpeningVideo(resource.screenId || '')"
                        [disabled]="resource.resourceType === 'video' && isOpeningVideo(resource.screenId || '')"
                        (click)="openHelpResource(resource)">
                        <span class="resource-inline-link">
                          {{ resource.resourceType === 'video'
                            ? (isOpeningVideo(resource.screenId || '') ? 'Opening video...' : 'Watch')
                            : 'Download' }}
                        </span>
                        <span class="resource-card-action-icon">
                          <ng-container *ngIf="resource.resourceType === 'video'; else resourceDownloadIcon">
                            <svg
                              class="resource-card-action-svg resource-card-action-svg--video"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="1.85"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              aria-hidden="true">
                              <path d="M10 8.5 16 12l-6 3.5z"></path>
                            </svg>
                          </ng-container>
                          <ng-template #resourceDownloadIcon>
                            <svg
                              class="resource-card-action-svg"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="1.95"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              aria-hidden="true">
                              <path d="M12 4.75v9.25"></path>
                              <path d="m8.75 10.9 3.25 3.35 3.25-3.35"></path>
                              <path d="M7 18.25h10"></path>
                            </svg>
                          </ng-template>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
